import {EMPTY_DATE} from '../constants';

const hasValidYear = ({formMonth, formYear, month, year} = {}) =>
  (month || formMonth) !== EMPTY_DATE
    ? (year || formYear) !== EMPTY_DATE
    : true;

export default hasValidYear;
